import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';
import { TypesOfBirth } from './TypesOfBirth';

export const Indicators = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Card
                title="Tempo Médio de Cadastro (em dias)"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averageRegistrationTime || 0
                )}
            />
            <Card
                title="Tempo Médio de Atestado de Óbito (em dias)"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averageTimeDeathCertificate || 0
                )}
            />
            <TypesOfBirth />
        </div>
    );
};
